<template>
  <div class="c-select">
    <label class="c-select__label" :for="'select' + type">{{ title }}</label>
    <div class="c-select__container">
      <select class="c-select__list" @change="change" :disabled="disabled">
        <option class="c-select__item" disabled value="none" :selected="selectedValue == null"
          >Vælg</option
        >
        <option
          v-for="item in items"
          :key="'select' + item.value"
          class="c-select__item"
          :selected="selectedValue == item.value"
          :value="item.value"
          >{{ item.title }}</option
        >
      </select>
    </div>
    <span class="c-select__validate-text">{{ validateText }}</span>
  </div>
</template>
<script>
// @ is an alias to /src
export default {
  name: 'Select',
  data() {
    return {
      title: this.dataTitle ? this.dataTitle : '',
      type: this.dataType ? this.dataType : '',
      items: this.dataItems ? this.dataItems : []
    };
  },
  props: {
    dataTitle: String,
    dataType: String,
    dataItems: Array,
    selectedValue: [Number, String],
    disabled: Boolean,
    validateText: String
  },
  methods: {
    change(e) {
      const item = this.items.find(x => x.value == e.target.value);
      this.$emit('childToParent', item);
    }
  }
};
</script>
<style lang="scss">
@import '@/assets/scss/essentials/essentials.scss';
@import './select';
</style>
